var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path, _line13, _line14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCatalogSpringIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.g{fill:none;}.b{fill:#3c3c46;opacity:0.2;}.c{fill:#fff;}.c,.d,.e,.f,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;}.c,.d,.e{stroke-width:2px;}.d{fill:#89d9fb;}.f{fill:#3ca4ef;fill-rule:evenodd;}.f,.g{stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-catalog-spring-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 32.42,
    y: 23,
    width: 86,
    height: 100
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 104.42,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 100.42,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 96.42,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 26.42,
    y: 17,
    width: 70,
    height: 100
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 55.54,
    x2: 21.58,
    y2: 55.54
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 63.18,
    x2: 21.58,
    y2: 63.18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 70.82,
    x2: 21.58,
    y2: 70.82
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 78.46,
    x2: 21.58,
    y2: 78.46
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 86.1,
    x2: 21.58,
    y2: 86.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 93.73,
    x2: 21.58,
    y2: 93.73
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 101.37,
    x2: 21.58,
    y2: 101.37
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 109.01,
    x2: 21.58,
    y2: 109.01
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 47.91,
    x2: 21.58,
    y2: 47.91
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 40.27,
    x2: 21.58,
    y2: 40.27
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 32.63,
    x2: 21.58,
    y2: 32.63
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 31.26,
    y1: 24.99,
    x2: 21.58,
    y2: 24.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M72.26,47.72l-2.7,2.7a7.5,7.5,0,1,0,0,10.6L78,69.48A19.45,19.45,0,1,1,78,42Z"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 49.68,
    y1: 86.69,
    x2: 74.68,
    y2: 86.69
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 49.68,
    y1: 91.69,
    x2: 74.68,
    y2: 91.69
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCatalogSpringIcon);
export default __webpack_public_path__ + "static/media/CP-catalog-spring-icon.6121ee19ee479bbbcd810438dc43da0a.svg";
export { ForwardRef as ReactComponent };